const apoderados = [
  { apoderado: '20262935079', path: '01-RESTON.png', nombre: 'RESTON, ANGEL', dni: '26.293.507', mail: 'asociart@estudioreston.com.ar' },
  { apoderado: '23276192914', path: '03-ALIAGA.png', nombre: 'ALIAGA, CAROLINA MARIA', dni: '27.619.291', mail: 'asociart@estudioreston.com.ar' },
  { apoderado: '23361302664', path: '04-TAYAGUI.png', nombre: 'TAYAGÜI, SOLEDAD NAIRA', dni: '36.130.266', mail: 'asociart@estudioreston.com.ar' },
  { apoderado: '20302216496', path: '02-CACHISUB.png', nombre: 'CACHISUB, FEDERICO JAVIER', dni: '30.221.649', mail: 'asociart@estudioreston.com.ar' },
]

export const obtenerApoderado = (cuil) => {
  const apoderado = cuil && apoderados.find(apod => apod.apoderado === cuil.trim())
  return apoderado
}

export const blobToHex = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsArrayBuffer(blob)
    reader.onloadend = () => {
      const arrayBuffer = reader.result
      const byteArray = new Uint8Array(arrayBuffer)
      const hexString = Array.from(byteArray, byte => byte.toString(16).padStart(2, '0')).join('')
      resolve('0x' + hexString)
    }
    reader.onerror = reject
  })
}

//Funcion para trasnformar el numero en palaras
export const numeroEnPalabras = (numero) => {
  const unidades = ['CERO', 'UNO', 'DOS', 'TRES', 'CUATRO', 'CINCO', 'SEIS', 'SIETE', 'OCHO', 'NUEVE']
  const decenas = ['DIEZ', 'ONCE', 'DOCE', 'TRECE', 'CATORCE', 'QUINCE', 'DIECISÉIS', 'DIECISIETE', 'DIECIOCHO', 'DIECINUEVE']
  const decenasY = ['DIECI', 'VEINTI', 'TREINTA', 'CUARENTA', 'CINCUENTA', 'SESENTA', 'SETENTA', 'OCHENTA', 'NOVENTA']
  const centenas = ['CIENTO', 'DOSCIENTOS', 'TRESCIENTOS', 'CUATROCIENTOS', 'QUINIENTOS', 'SEISCIENTOS', 'SETECIENTOS', 'OCHOCIENTOS', 'NOVECIENTOS']

  function convertirMenor1000(numero) {
    let resultado = '';
    if (numero >= 100) {
      if (numero === 100) {
        resultado += 'CIEN';
      } else {
        resultado += centenas[Math.floor(numero / 100) - 1] + ' ';
        numero = numero % 100;
      }
    }
    if (numero >= 20) {
      const decena = decenasY[Math.floor(numero / 10) - 1];
      if (decena === 'DIECI' || decena === 'VEINTI') {
        resultado += decena;
        if (numero % 10 !== 0) {
          resultado += '' + unidades[numero % 10];
        }
        else
          resultado = 'VEINTE'
      } else {
        resultado += decena;
        if (numero % 10 !== 0) {
          resultado += ' Y ' + unidades[numero % 10];
        }
      }
    } else if (numero >= 10) {
      resultado += decenas[numero - 10];
    } else if (numero > 0) {
      resultado += unidades[numero];
    }
    return resultado.trim();
  }

  function convertirMiles(numero) {
    let miles = Math.floor(numero / 1000)
    let resto = numero % 1000
    let resultado = ''
    if (miles > 0) {
      if (miles === 1) {
        resultado += 'MIL'
      } else {
        resultado += convertirMenor1000(miles) + ' MIL'
      }
    }
    if (resto > 0) {
      resultado += ' ' + convertirMenor1000(resto)
    }
    return resultado.trim()
  }

  function convertirMillones(numero) {
    let millones = Math.floor(numero / 1000000)
    let resto = numero % 1000000
    let resultado = ''
    if (millones > 0) {
      if (millones === 1) {
        resultado += 'UN MILLON'
      } else {
        resultado += convertirMenor1000(millones) + ' MILLONES'
      }
    }
    if (resto > 0) {
      resultado += ' ' + convertirMiles(resto)
    }
    return resultado.trim()
  }

  function convertirCentavos(numero) {
    return numero + "/100"
  }

  let partes = numero.toString().split('.')
  let entero = parseInt(partes[0].replace(/,/g, ''))
  let centavos = partes.length > 1 ? partes[1] : '00'

  let resultado = convertirMillones(entero) + ' CON ' + convertirCentavos(centavos)
  return resultado
}

export const convertFileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  })
}

export const validarCuit = (cuit) => {
  if (cuit === '00000000000')
    return false

  if (cuit.length !== 11) {
    return false;
  }

  let acumulado = 0;
  let digitos = cuit.split('');
  let digito = parseInt(digitos.pop());

  for (let i = 0; i < digitos.length; i++) {
    acumulado += digitos[9 - i] * (2 + (i % 6));
  }

  let verif = 11 - (acumulado % 11);
  if (verif === 11) {
    verif = 0;
  } else if (verif === 10) {
    verif = 9;
  }
  return digito === verif;
}

// Método 1: operando dígitos

// Método 1: operando dígitos
function validarLargoCBU(numero) {
  if (numero)
    if (numero.length !== 22) { return false }
  return true
}
function validarBloque1(bloque1) {
  if (bloque1.length !== 8) return false;

  const banco = bloque1.substr(0, 3);
  const digitoVerificador1 = parseInt(bloque1[3]);
  const sucursal = bloque1.substr(4, 3);
  const digitoVerificador2 = parseInt(bloque1[7]);

  const suma =
    banco[0] * 7 +
    banco[1] * 1 +
    banco[2] * 3 +
    digitoVerificador1 * 9 +
    sucursal[0] * 7 +
    sucursal[1] * 1 +
    sucursal[2] * 3;

  const diferencia = (10 - (suma % 10)) % 10;
  return diferencia === digitoVerificador2;
}

function validarBloque2(bloque2) {
  if (bloque2.length !== 14) return false;

  const digitoVerificador = parseInt(bloque2[13]);
  const suma =
    bloque2[0] * 3 +
    bloque2[1] * 9 +
    bloque2[2] * 7 +
    bloque2[3] * 1 +
    bloque2[4] * 3 +
    bloque2[5] * 9 +
    bloque2[6] * 7 +
    bloque2[7] * 1 +
    bloque2[8] * 3 +
    bloque2[9] * 9 +
    bloque2[10] * 7 +
    bloque2[11] * 1 +
    bloque2[12] * 3;

  const diferencia = (10 - (suma % 10)) % 10;
  return diferencia === digitoVerificador;
}

export const validarCBU = (nrocbu) => {

  if (nrocbu === '0000000000000000000000')
    return false

  return nrocbu
    ? validarLargoCBU(nrocbu) &&
    validarBloque1(nrocbu.substr(0, 8)) &&
    validarBloque2(nrocbu.substr(8, 14))
    : false;
}

export const mostrarTipoFactura = (tipoFactura) => {
  switch (tipoFactura) {
    case "FCJ": return "Factura"
    case "CDJ": return "Contestación Demanda"
    default: return ""
  }
}


export const mostrarTipoDocumentoObservacion = (tipoDoc) => {
  switch (tipoDoc) {
    case "ACLPCONT-SIPE": return "Aclaraciones perito contador"
    case "ACLPMED-SIPE": return "Aclaraciones perito médico"
    case "ACLPPSC-SIPE": return "Aclaraciones perito psicólogo"
    case "ACLPPSQ-SIPE": return "Aclaraciones perito psiquiatra "
    case "ACLPTEC-SIPE": return "Aclaraciones perito técnico"
    case "ACTAUD-SIPE": return "Acta de Audiencia"
    case "MED-SIPE": return "Acta de Cierre MEDIACION EXTRAJUDICIAL"
    case "AJ-SIPE": return "Acuerdo judicial"
    case "ACUM-SIPE": return "Acumulación"
    case "ALEGATO-SIPE": return "Alegato"
    case "AP-SIPE": return "Apelación"
    case "APLETCIA-SIPE": return "Aportes letrado Cía."
    case "ASIGDEM-SIPE": return "Asignación de Demandas"
    case "AU-SIPE": return "Audiencia"
    case "BUDI-SIPE": return "BUDI"
    case "CAD-SIPE": return "Caducidad"
    case "CADPRU-SIPE": return "Caducidad de prueba"
    case "CAJAFOR-SIPE": return "Caja Forense"
    case "CA-SIPE": return "Carátula"
    case "CD-SIPE": return "Carta documento"
    case "CAUP-SIPE": return "Causa Penal"
    case "CBU-SIPE": return "CBU"
    case "CE-SIPE": return "cedula de Notificacion"
    case "CONSIG-SIPE": return "Consignación Judicial"
    case "CONS-SIPE": return "Contestación"
    case "CO-SIPE": return "Contestación de demanda"
    case "CONVHONO-SIPE": return "Convenio de honorarios"
    case "COSJUZ-SIPE": return "Cosa Juzgada"
    case "DACPAG-SIPE": return "Dación en pago Embargo"
    case "DE-SIPE": return "Demanda"
    case "DESIST-SIPE": return "Desistimiento"
    case "DICF-SIPE": return "Dictamen Fiscal"
    case "DO-SIPE": return "Documentación"
    case "EMBA-SIPE": return "Embargo"
    case "ESC-SIPE": return "Escrito mero tramite"
    case "EXSRTL-SIPE": return "Expediente SRT"
    case "FC-SIPE": return "Factura"
    case "HO-SIPE": return "Homologación"
    case "HP-SIPE": return "Honorarios Peritos"
    case "IBM-SIPE": return "IBM"
    case "SABAFIP-SIPE": return "IBM AFIP"
    case "IMPUGLI-SIPE": return "Impugna Planilla de Liquidación"
    case "IM-SIPE": return "Impugnación"
    case "IMPPC-SIPE": return "Impugnación PC"
    case "IMPPMO-SIPE": return "Impugnación PMO"
    case "IMPPSPPQ-SIPE": return "Impugnación PPS/PPQ"
    case "IMPPTO-SIPE": return "Impugnación PTO"
    case "IMPUCON-SIPE": return "Imputación contable Embargo"
    case "INCOMP-SIPE": return "Incompetencia"
    case "INFCACR-SIPE": return "Informe Caso crítico"
    case "INFRIES-SIPE": return "Informe de riesgo judicial"
    case "INFGE-SIPE": return "Informe Gerencia"
    case "ISCLO-SIPE": return "Informe SeCLO"
    case "INFSENT-SIPE": return "Informe Sentencia"
    case "ITEJ-SIPE": return "Informe trimestral EJ"
    case "INTIVA-SIPE": return "Intimación IVA"
    case "JUICIOCO-SIPE": return "Juicio Completo"
    case "JM-SIPE": return "Junta Médica Privada"
    case "LEVAEMB-SIPE": return "Levantamiento embargo"
    case "LIBGIR-SIPE": return "Libramiento de giros"
    case "LI-SIPE": return "Liquidación"
    case "LIQSEN-SIPE": return "Liquidación sentencia"
    case "LITP-SIPE": return "Litispendencia"
    case "NS-SIPE": return "Memo de no seguro"
    case "MO-SIPE": return "Memo de ofrecimiento"
    case "MOVM-SIPE": return "Movimientos PJN/MEV"
    case "NSIS-SIPE": return "No seguro - Informe Síndicos"
    case "ARCHIV-SIPE": return "Nota de baja por Archivado/Paralizado"
    case "NOTIF-SIPE": return "Notificación"
    case "OFEMB-SIPE": return "Oficio embargo"
    case "ORDEMB-SIPE": return "Orden de Embargo"
    case "PE-SIPE": return "Otras pericias"
    case "PERCALI-SIPE": return "Pericia caligráfica"
    case "PC-SIPE": return "Pericia contable"
    case "PERINF-SIPE": return "Pericia informática"
    case "PM-SIPE": return "Pericia médica"
    case "PPC-SIPE": return "Pericia psicológica"
    case "PSI-SIPE": return "Pericia psicológica / psiquiátrica"
    case "PPQ-SIPE": return "Pericia psiquiátrica"
    case "PT-SIPE": return "Pericia técnica"
    case "LIQUICON-SIPE": return "Planilla de Liquidación CONJUNTA"
    case "LIQUIDI-SIPE": return "Planilla de Liquidación por diferencia"
    case "LIQUISEC-SIPE": return "Planilla de Liquidación por Secretaría"
    case "LIQUISEN-SIPE": return "Planilla de liquidación Sentencia"
    case "PRESCRIP-SIPE": return "Prescripción"
    case "PRESEN-SIPE": return "Presentación"
    case "PROVEI-SIPE": return "Proveído"
    case "RATIF-SIPE": return "Ratificación"
    case "REBD-SIPE": return "Rebeldía"
    case "RECSUE-SIPE": return "Recibos de sueldo"
    case "QUEJA-SIPE": return "Recurso de queja"
    case "RE-SIPE": return "Recurso extraordinario"
    case "REGHON-SIPE": return "Regulación honorarios"
    case "RI-SIPE": return "Resolución interlocutoria"
    case "RESI1I-SIPE": return "Resolución Interlocutoria de 1era instancia"
    case "RESIC-SIPE": return "Resolución Interlocutoria de Cámara"
    case "RESSRT-SIPE": return "Resolución SRT"
    case "RESTF-SIPE": return "Restitución de fondos"
    case "SALC-SIPE": return "Saldo cuenta judicial"
    case "SE-SIPE": return "Sentencia"
    case "SENTCORTNAC-SIPE": return "Sentencia Corte Nacional"
    case "SENTCORPROV-SIPE": return "Sentencia Corte Provincial"
    case "SENTCAM-SIPE": return "Sentencia de Cámara"
    case "SENTPRIMINST-SIPE": return "Sentencia Primera Instancia"
    case "SUM-SIPE": return "Sumario"
    case "SUMCOM-SIPE": return "Sumario Completo"
    case "SUSAU-SIPE": return "Suspensión Audiencia"
    case "TASA-SIPE": return "Tasa"
    case "TDJ-SIPE": return "Tasa de Justicia"
    case "TG-SIPE": return "Telegrama"
    case "TESTMO-SIPE": return "Testimoniales"
    default: return ""
  }
}

export const obtenerMesYAnio = (fecha) => {

  // Verifica si la fecha es un string en formato "DD/MM/YYYY"
  if (typeof fecha === "string" && fecha.includes("/")) {
    const [dia, mes, anio] = fecha.split("/");
    fecha = `${anio}-${mes}-${dia}`; // Convertimos a "YYYY-MM-DD"
  }
  const fechaObj = new Date(fecha); // Asegurar que es un objeto Date
  const opciones = { month: "long" }; // Obtener solo el mes en letras
  let mes = fechaObj.toLocaleString("es-ES", opciones);
  mes = mes.charAt(0).toUpperCase() + mes.slice(1); // Convertir primera letra en mayúscula
  const anio = fechaObj.getFullYear(); // Obtener el año
  return `${mes} ${anio}`;
};

export const convertirNumero = (numeroString) => {
  if (!numeroString) return null;
  return parseFloat(numeroString.replace(/\./g, "").replace(",", "."));
}

export const formatearNumero = (valor) => {
  if (valor === null || valor === undefined) return "";

  // Asegura que sea número y redondea a 2 decimales
  const valorRedondeado = Number(valor).toFixed(2); // ← aquí está el cambio importante

  // Convierte punto decimal a coma
  const strValor = valorRedondeado.replace(".", ",");

  // Divide parte entera y decimal
  const [entera, decimal] = strValor.split(",");

  // Limpia puntos existentes y formatea con puntos de miles
  const limpiaEntera = entera.replace(/\./g, "");
  const parteEnteraFormateada = limpiaEntera.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  // Devuelve con coma y decimales
  return `${parteEnteraFormateada},${decimal}`;
};

export const getFechaLocal = () => {
  const hoy = new Date()
  const year = hoy.getFullYear()
  const month = String(hoy.getMonth() + 1).padStart(2, '0')
  const day = String(hoy.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

//funcion que le pase un nombre y me devuelva las iniciales
export const obtenerIniciales = (nombre) => {
  if (!nombre) return "";
  const palabras = nombre.trim().split(" ");
  const iniciales = palabras.map(palabra => palabra.charAt(0).toUpperCase()).join("");
  return iniciales;
}

